const RELOAD_KEY = 'erp_chunk_reload_attempted'

/** 发版后旧主包/异步 chunk 被 rsync --delete 清掉时，浏览器会报 ChunkLoadError（含 CSS chunk）。 */
export function isChunkLoadError(reason) {
  if (!reason) return false
  const name = reason?.name || ''
  if (name === 'ChunkLoadError') return true
  const msg = String(reason?.message || (typeof reason === 'string' ? reason : '') || '')
  return /Loading (?:CSS )?chunk [\w-]+ failed/i.test(msg)
}

/**
 * 尝试自动刷新一次以拉取新 index.html 与 hash 资源。
 * @returns {boolean} 已处理（含已刷新或已提示用户强刷）
 */
export function tryReloadOnceOnChunkError(notify) {
  if (!sessionStorage.getItem(RELOAD_KEY)) {
    sessionStorage.setItem(RELOAD_KEY, '1')
    notify?.('检测到前端资源已更新，正在刷新页面…')
    window.location.reload()
    return true
  }
  sessionStorage.removeItem(RELOAD_KEY)
  notify?.('静态资源加载失败，请使用强制刷新（Ctrl+F5 / Cmd+Shift+R）或清除站点缓存后重试')
  return true
}

export function clearChunkReloadAttemptFlag() {
  sessionStorage.removeItem(RELOAD_KEY)
}
